export { ClozeParagraphText } from './ClozeParagraphText';
